module.exports = __webpack_public_path__ + "static/media/roo_wor_gua_all_ope.fd497ba4.png";